import { type AddLayerOptions } from '@iib/pandora-box';
export type LayerStyleType = {
  sources: Record<
    string,
    {
      type: 'vector' | 'raster';
      url: string;
    }
  >;

  layers: Array<AddLayerOptions>;
};
export const CURRENT_YEAR = new Date().getFullYear();
export const MAP_ATTRIBUTION = `
  © <a href="https://www.iib-institut.de/impressum" target="_blank">IIB Institut GmbH</a> 
  © <a href="https://www.maptoolkit.com/" target="_blank">Maptoolkit</a>
  © <a href="https://www.openstreetmap.org/about/" target="_blank">OSM</a>
`;

export const MAP_ID = 'wohnpreis-map';

export const GERMANY_CENTER = [10.4515, 51.1657];

export const fetchLagescoreStyle = async () => {
  const result: LayerStyleType = await fetch(
    'https://static.maptoolkit.net/styles/iib/iib_lagescores_zf5l.json?api_key=iib',
  ).then((res) => res.json());
  return result;
};

export const MAX_ZOOM = 17.9;
export const MIN_ZOOM = 10.5;
export const PITCH = 0;
export const BEARING = 0;
